import { Post } from "@/wp/types/client";
import { getData } from "./getData";

export async function getAudioData({
  audioId,
  fields,
  locale,
  defaultLocale,
}: {
  audioId: string;
  fields?: string;
  locale?: string;
  defaultLocale?: string;
}): Promise<Post<"audios"> | null> {
  const url = "/audios/" + audioId + (fields ? `?_fields=${fields}` : "");
  const response = await getData(url, locale, defaultLocale);
  if (!response) {
    throw new Error(`Audio with ID ${audioId} not found`);
  }
  return response as Post<"audios">;
}
